import { http } from '../utils/axios';

import { API_URLS } from '../constants';

export const commoninfoApi = {
  getAllCommonInfosRequest() {
    return http({ url: API_URLS.commonInfo }).then((res) => res.data);
  },
};
